"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const contact_controller_1 = require("./contact.controller");
const contact_service_1 = require("./contact.service");
const contact_entity_1 = require("../../../../service-lib/src/lib/entities/contact.entity");
const contact_repository_1 = require("./contact.repository");
const address_repository_1 = require("../address/address.repository");
const company_repository_1 = require("../company/company.repository");
const address_entity_1 = require("../../../../service-lib/src/lib/entities/address.entity");
const contact_address_entity_1 = require("../../../../service-lib/src/lib/entities/contact-address.entity");
const company_contact_entity_1 = require("../../../../service-lib/src/lib/entities/company-contact.entity");
const contact_details_entity_1 = require("../../../../service-lib/src/lib/entities/contact-details.entity");
const professional_experience_entity_1 = require("../../../../service-lib/src/lib/entities/professional-experience.entity");
const qualification_experience_entity_1 = require("../../../../service-lib/src/lib/entities/qualification-experience.entity");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard"); // Import AuthGuard here
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard"); // Import RolesGuard here
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const look_up_repository_1 = require("../look-up/look-up.repository");
const company_entity_1 = require("../../../../service-lib/src/lib/entities/company.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const company_address_entity_1 = require("../../../../service-lib/src/lib/entities/company.address.entity");
const jwt_1 = require("@nestjs/jwt");
const contact_document_map_entity_1 = require("../../../../service-lib/src/lib/entities/contact-document-map.entity");
const contact_communication_details_entity_1 = require("../../../../service-lib/src/lib/entities/contact-communication-details.entity");
const insurer_entity_1 = require("../../../../service-lib/src/lib/entities/insurer.entity");
const insurer_contact_entity_1 = require("../../../../service-lib/src/lib/entities/insurer-contact.entity");
const insurer_address_entity_1 = require("../../../../service-lib/src/lib/entities/insurer-address.entity");
const insurer_repository_1 = require("../insurer/insurer.repository");
const tpa_entity_1 = require("../../../../service-lib/src/lib/entities/tpa.entity");
const tpa_address_entity_1 = require("../../../../service-lib/src/lib/entities/tpa-address.entity");
const tpa_contact_entity_1 = require("../../../../service-lib/src/lib/entities/tpa-contact.entity");
const tpa_repository_1 = require("../tpa/tpa.repository");
const child_details_entity_1 = require("../../../../service-lib/src/lib/entities/child-details.entity");
const broker_repository_1 = require("../broker/broker.repository");
const broker_entity_1 = require("../../../../service-lib/src/lib/entities/broker.entity");
const broker_address_entity_1 = require("../../../../service-lib/src/lib/entities/broker-address.entity");
const broker_contact_entity_1 = require("../../../../service-lib/src/lib/entities/broker-contact.entity");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const opportunity_entity_1 = require("../../../../service-lib/src/lib/entities/opportunity.entity");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
/**
 * Module for managing contacts.
 */
let ContactModule = class ContactModule {
};
exports.ContactModule = ContactModule;
exports.ContactModule = ContactModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                contact_entity_1.Contact,
                address_entity_1.Address,
                contact_address_entity_1.ContactAddress, // Ensure ContactAddress is included here
                company_contact_entity_1.CompanyContactMap,
                contact_details_entity_1.ContactDetails,
                child_details_entity_1.ChildDetails,
                professional_experience_entity_1.ProfessionalExperience,
                qualification_experience_entity_1.QualificationExperience,
                company_address_entity_1.CompanyAddress,
                company_entity_1.Company,
                look_up_entity_1.LookUp,
                contact_document_map_entity_1.ContactDocMap,
                contact_communication_details_entity_1.ContactCommunicationDetails,
                insurer_entity_1.Insurer,
                insurer_contact_entity_1.InsureContact,
                insurer_address_entity_1.InsurerAddress,
                tpa_entity_1.Tpa,
                tpa_address_entity_1.TpaAddress,
                tpa_contact_entity_1.TpaContact,
                broker_entity_1.Broker,
                broker_address_entity_1.BrokerAddress,
                broker_contact_entity_1.BrokerContact,
                opportunity_entity_1.Opportunity,
            ]),
            jwt_1.JwtModule,
        ],
        controllers: [contact_controller_1.ContactController],
        providers: [
            contact_service_1.ContactService,
            contact_repository_1.ContactRepository,
            address_repository_1.AddressRepository,
            company_repository_1.CompanyRepository,
            entity_service_utils_1.EntityService,
            insurer_repository_1.InsurerRepository,
            tpa_repository_1.TpaRepository,
            broker_repository_1.BrokerRepository,
            look_up_repository_1.LookUpRepository,
            lookup_validation_1.LookUpValidationService,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            scope_utils_1.ScopeService
        ],
        exports: [contact_service_1.ContactService],
    })
], ContactModule);
